import AuthenticationContext, { IAuthenticationContext } from "@myinnsworth/contexts/AuthenticationContext";
import { useContext } from "react";

export function useAuthentication(): IAuthenticationContext {
    const auth = useContext<IAuthenticationContext>(AuthenticationContext);
    return auth;
}